<div mat-dialog-content class="dialog">
  <h3>{{editMode ?"Redigera abonnemang" : "Skapa nytt abonnemang"}}</h3>
  @if (prepaidForm) {
    <form [formGroup]="prepaidForm" spellcheck="false" autocomplete="off">
      <div class="form-fieldset">
        <!-- Ticket name -->
        <mat-form-field>
          <mat-label>Kontonamn</mat-label>
          <input matInput name="name" formControlName="name" data-test="name" required spellcheck="false"
            (change)="updatePrepaidTicket()" />
          </mat-form-field>
          <!-- Amount of cars -->
          <mat-form-field>
            <mat-label>Max samtidiga bilar</mat-label>
            <input matInput type="number" name="maxCars" formControlName="maxCars" data-test="maxCars" required (change)="updatePrepaidTicket()" />
          </mat-form-field>
        </div>
        <!-- Dates -->
        <mat-form-field>
          <mat-label>Giltighetstid</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate name="validFrom" formControlName="validFrom" data-test="validFrom" placeholder="Startdatum"
              (dateChange)="updatePrepaidTicket()" />
              <input matEndDate name="validTo" formControlName="validTo" data-test="validTo" placeholder="Slutdatum"
                (dateChange)="updatePrepaidTicket()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <div class="form-fieldset">
              <!-- Price -->
              <mat-form-field>
                <mat-label>Pris</mat-label>
                <input matInput type="number" name="amount" formControlName="amount" data-test="amount" (change)="updatePrepaidTicket()" />
              </mat-form-field>
              <!-- Comment -->
              <mat-form-field>
                <mat-label>Kommentar</mat-label>
                <input matInput name="comment" formControlName="comment" data-test="comment" (change)="updatePrepaidTicket()" />
              </mat-form-field>
            </div>
            <!-- Features -->
            <div class="form-fieldset types">
              <div>
                <h4>Parkeringstyp</h4>
                <mat-radio-group name="resource" formControlName="resource" (change)="updatePrepaidTicket()">
                  @for (resource of resourceOptions; track resource) {
                    <mat-radio-button color="primary" [value]="resource"
                      [checked]="resource.resourceId === prepaidTicket?.resource?.resourceId">
                      {{resource.label}}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
              <!-- Active -->
              @if (editMode) {
                <div>
                  <h4>Aktivt</h4>
                  <mat-checkbox color="primary" name="active" formControlName="active" (change)="updatePrepaidTicket()"></mat-checkbox>
                </div>
              }
            </div>
            <!-- Included cars -->
            <h4>Inkluderade bilar</h4>
            <div class="included-cars-wrapper">
              @if (prepaidTicket?.cars?.length) {
                <div class="included-cars">
                  <!-- Registration numbers -->
                  <ul>
                    @for (car of prepaidTicket?.cars; track car; let i = $index) {
                      <li>
                        <mat-icon>directions_car</mat-icon>
                        <span>{{car?.registrationNumber}}</span>
                        <mat-icon class="remove-discount" title="Ta bort registreringsnummer"
                        (click)="removeCar(prepaidTicket?.cars?.[i])">clear</mat-icon>
                      </li>
                    }
                  </ul>
                </div>
              }
              <div class="form-fieldset">
                <mat-form-field class="registration-number">
                  <mat-label class="label">Registreringsnummer</mat-label>
                  <input matInput name="car" formControlName="car" data-test="car" />
                  <!-- Add button -->
                </mat-form-field>
                <button title="Lägg till registreringsnummer" class="add-btn button slim"
                  (click)="updatePrepaidTicket(); clearCarInput()">
                  lägg till
                </button>
              </div>
            </div>
            @if (invalidFormMessage) {
              <div class="invalid-message">
                <mat-icon>error</mat-icon> <span>{{ invalidFormMessage }}</span>
                <mat-icon>error</mat-icon>
              </div>
            }
            <div mat-dialog-actions class="action-buttons">
              <button mat-button (click)="onCancelClick()">Avbryt</button>
              <div>
                @if (!data.create) {
                  <button class="delete" mat-button (click)="onRemoveClick()">Ta bort</button>
                }
                <button mat-raised-button (click)="onCreateClick()" color="primary">
                  Spara
                </button>
              </div>
            </div>
          </form>
        }
      </div>